/**
 * @name NotFound
 * @description Componente para mostrar icono y mensaje al no encontrar ningún elemento
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Flex, Unicons } from '@styles';

const NotFound = ({ message }) => {
  return (
    <Flex.Row flex="100%">
      <Styled.BoxIcon>
        <Unicons.CircleExclamation size="20" />
      </Styled.BoxIcon>
      {message}
    </Flex.Row>
  );
};

NotFound.propTypes = {
  // Mensaje que se muestra dentro del componente.
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.BoxIcon = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  margin-right: 8px;
`;

export default NotFound;